import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { NgxMaskDirective, provideNgxMask, NgxMaskPipe } from "ngx-mask";
import { ImageViewerModule } from "src/app/views/pages/mad_shared/image-viewer/image-viewer.module";
import { MadSharedModule } from "src/app/views/pages/mad_shared/shared.module";
import { LandAreaDialogComponent } from "./land-area-dialog/land-area-dialog.component";
import { LandAreasComponent } from "./land-areas.component";
import { PlaningStatusesService, QosDegradationsService } from "src/app/core/linked-tables";
import { LinkedTableAddDialogModule } from "../linked-table-add-dialog/linked-table-add-dialog.module";

@NgModule({
  imports: [
        LinkedTableAddDialogModule,
    CommonModule,
    ReactiveFormsModule,

    TranslateModule.forChild(),
    NgbPopoverModule,
    NgxMaskDirective,
    NgxMaskPipe,

    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    ImageViewerModule,
  ],
  declarations: [
    LandAreasComponent,
    LandAreaDialogComponent
  ],
  exports: [
    LandAreasComponent
  ],
  providers: [
        PlaningStatusesService,
        QosDegradationsService,
    provideNgxMask()
  ]
})
export class LandAreasModule {}